import React from 'react'
import { useTranslation } from 'react-i18next'

import { Button } from '../../../../global/button/Button'
import { useFormatNumber } from '../../../../hooks/useFormatNumber'
import { BlueTimeIcon } from '../../../../icons/BlueTimeIcon'
import { MasterTransactionDto } from '../../../../model/MasterTransactionDto'
import { Text, TextStrong } from '../../../../ui/Typography/Typography'
import { Modal } from '../../../../ui/v2/Modal'
import { cloneButtonLarge } from '../../../../ui/v2/Modal/common/helpers/button'

import styles from '../../WalletSuccessModal.module.scss'

interface Props {
  transaction: MasterTransactionDto | undefined
  onCancel(): void
}

export const WalletWithdrawSuccessModal: React.FC<Props> = ({ onCancel, transaction }) => {
  const { t } = useTranslation()

  return (
    <Modal.SuccessMessage
      icon={<BlueTimeIcon color='white' />}
      title={t('Wallet.Withdrawal request submitted')}
      onClose={onCancel}
      headerless={true}
      renderFooter={() => [
        cloneButtonLarge(
          <Button.New appearance='primary' onClick={onCancel} className={styles.button}>
            {t('Got it')}
          </Button.New>
        ),
      ]}
    >
      <WithdrawalSuccessModalBody transaction={transaction} />
    </Modal.SuccessMessage>
  )
}

interface BodyProps {
  transaction?: MasterTransactionDto
}

const WithdrawalSuccessModalBody: React.FC<BodyProps> = (props) => {
  const { transaction } = props

  const { t } = useTranslation()
  const { formatMoney } = useFormatNumber()

  if (!transaction) {
    return null
  }

  const [walletTransaction] = transaction.walletTransactions
  const amount =
    transaction.groupReference?.totalPaymentsAmount ??
    transaction.groupReference?.totalWalletsAmount ??
    walletTransaction?.otherAmount
  const paymentAgentTransaction = transaction.walletTransactions.find(
    (walletTransaction) => walletTransaction?.paymentAgentTransaction?.paymentAgent
  )

  return (
    <div className={styles.wrapper}>
      <div className={styles.column}>
        <Text className={styles.from} isParagraph>
          {t('Wallet.From')}
        </Text>
        <TextStrong isParagraph>
          {walletTransaction?.wallet?.currency?.id} {t('Wallet.Wallet')}
        </TextStrong>
      </div>

      <div className={styles.column}>
        <Text isParagraph>{t('Wallet.Amount')}</Text>
        <TextStrong isParagraph>
          {formatMoney(amount, walletTransaction?.otherCurrency?.id)}
        </TextStrong>
      </div>

      <div className={styles.column}>
        <Text isParagraph>{t('Wallet.Payment Method')}</Text>
        <TextStrong isParagraph className='px-5 has-text-centered'>
          {walletTransaction?.paymentProviderTransaction?.paymentProvider?.name ||
            paymentAgentTransaction?.paymentAgentTransaction?.paymentAgent?.name}
        </TextStrong>
      </div>
    </div>
  )
}
